import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SetupModalPage } from './setup-modal';

@NgModule({
  declarations: [
    SetupModalPage,
  ],
  imports: [
    IonicPageModule.forChild(SetupModalPage),
  ],
})
export class SetupModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/setup-modal/setup-modal.module.ts